import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Navbar } from "@/components/Navbar";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import { LoginPage, RegisterPage } from "@/pages/Auth";
import EventsPage from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import FaceSearch from "@/pages/FaceSearch";
import CartPage from "@/pages/Cart";
import OrdersPage from "@/pages/Orders";
import PurchasesPage from "@/pages/Purchases";
import PhotographerDashboard from "@/pages/PhotographerDashboard";
import PhotographerEvent from "@/pages/PhotographerEvent";
import PhotographerOrders from "@/pages/PhotographerOrders";
import PhotographerProfile from "@/pages/PhotographerProfile";
import AdminPage from "@/pages/Admin";
import PhotographerPromos from "@/pages/PhotographerPromos";
import PhotographerPackages from "@/pages/PhotographerPackages";
import StudioProfile, { StudioList } from "@/pages/Studio";

const guard = (el, roles) => <ProtectedRoute roles={roles}>{el}</ProtectedRoute>;

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-[#FAFAFA]">
            <Navbar />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/events" element={<EventsPage key="event" kind="event" />} />
              <Route path="/non-event" element={<EventsPage key="non_event" kind="non_event" />} />
              <Route path="/events/:id" element={<EventDetail />} />
              <Route path="/studio" element={<StudioList />} />
              <Route path="/studio/:id" element={<StudioProfile />} />
              <Route path="/cari" element={guard(<FaceSearch />, ["member"])} />
              <Route path="/keranjang" element={<CartPage />} />
              <Route path="/pesanan" element={guard(<OrdersPage />, ["member"])} />
              <Route path="/koleksi" element={guard(<PurchasesPage />, ["member"])} />
              <Route path="/fotografer" element={guard(<PhotographerDashboard />, ["photographer"])} />
              <Route path="/fotografer/event/:id" element={guard(<PhotographerEvent />, ["photographer"])} />
              <Route path="/fotografer/pesanan" element={guard(<PhotographerOrders />, ["photographer", "admin"])} />
              <Route path="/fotografer/profil" element={guard(<PhotographerProfile />, ["photographer"])} />
              <Route path="/fotografer/promo" element={guard(<PhotographerPromos />, ["photographer"])} />
              <Route path="/fotografer/paket" element={guard(<PhotographerPackages />, ["photographer"])} />
              <Route path="/admin" element={guard(<AdminPage />, ["admin"])} />
            </Routes>
          </div>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
